import React from 'react';

function Hero() {
  return (
    <section className="hero" id="home">
      <h1 className="hero-title">Nirvalis - Health Intelligence Partner</h1>
      <p className="hero-tagline">Your health. Your data. Your advocate.</p>
      <p className="hero-subtitle">
        Creating healthier generations—starting with you.
      </p>
      <p className="hero-description">
        An AI-powered health intelligence assistant that gives every member a lifelong,
        member-owned health graph and catches early signals before symptoms surface.
      </p>
    </section>
  );
}

export default Hero;
